import React from "react";
import { useEffect, useState } from "react";

import { Col, Container, Row } from "react-bootstrap";
import { IoChevronForwardOutline } from "react-icons/io5";
import { AiOutlineRadarChart } from "react-icons/ai";
// import { FaChartLine } from "react-icons/fa";

import SkillsRadar from "../components/SkillsRadar";
import Loading from "../../loading/pages/Loading";
import SkillsModal from "../components/SkillsModal";
import { exerciseShortName, getPercentage } from "../utils/functions";
import { getRequest } from "../../api/axiosRequests";
import { PALETTE } from "../../common/ThemeConstants";
import { useAuth } from "../../auth/hook";
import UserAvatar from "../../common/components/UserAvatar";
import { FaWeightScale } from "react-icons/fa6";
import { GiBodyHeight } from "react-icons/gi";
import { useNavigate } from "react-router-dom";
import AccountAvatar from "../components/AccountAvatar";

export default function Skills() {
  const auth = useAuth();
  let user = auth.user;
  const [data, setData] = useState([]);
  const [exerciseList, setExerciseList] = useState([]);
  const [isLoaded, setIsLoaded] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();
  const percentage = getPercentage(user);

  const fetchData = async () => {
    const headers = { Authorization: localStorage.getItem("jwt") };
    if (user.id === -1) {
      try {
        const promiseUser = await getRequest("userData/", headers);
        user = promiseUser.data["data"];
      } catch (err) {
        alert("Error fetching data, please retry!");
        setIsLoaded(false);
        return;
      }
    }
    const promise1 = getRequest(
      "userExerciseMaximumForUser/" + user.id,
      headers
    );
    const promise2 = getRequest("exerciseList/", headers);
    Promise.all([promise1, promise2])
      .then((values) => {
        const userExercisesData = values[0].data;
        const exercisesData = values[1].data;
        let userExercises = [];
        if (userExercisesData !== undefined && userExercisesData.length > 0) {
          userExercisesData.forEach((element) => {
            userExercises.push(element);
          });
        }
        const nonRelatedExercises = exercisesData.filter((e) => {
          return e.relatedExerciseMaximum === null && e.primary;
        });
        nonRelatedExercises.forEach((nonRelatedExercise, idx) => {
          let found = false;
          userExercises.forEach((userExercise) => {
            if (userExercise["exercise"] === nonRelatedExercise.id) {
              userExercise["name"] = nonRelatedExercise.name;
              found = true;
            }
          });
          if (!found) {
            userExercises.push({
              id: -1,
              user: user.id,
              exercise: nonRelatedExercise.id,
              maximumWeight: 0,
              name: nonRelatedExercise.name,
            });
          }
        });

        // Sort the user exercises by name
        userExercises.sort((a, b) => {
          const nameA = a.name.toLowerCase();
          const nameB = b.name.toLowerCase();
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
          return 0;
        });

        setExerciseList(userExercises);

        // Create the data for the radar chart
        const radarData = [];

        // Add the exercise maximum data to the radar chart if the exercise is favourite
        userExercises.forEach((userExercise) => {
          if (userExercise.favourite) {
            const name = userExercise.name;
            const shortName = exerciseShortName(name);
            const weight = userExercise.maximumWeight;
            const trend = weight - userExercise.oldMaximumWeight;
            const dataElement = {
              subject: shortName,
              name: name,
              A: weight,
              trend: trend,
              fullMark: 150,
            };
            radarData.push(dataElement);
          }
        });

        // If there are no favourite exercises, set 5 blank exercises
        if (radarData.length === 0) {
          for (let i = 0; i < 5; i++) {
            const dataElement = {
              subject: "",
              name: "",
              A: 0,
              trend: 0,
              fullMark: 150,
            };
            radarData.push(dataElement);
          }
        }

        setData(radarData);
        setIsLoaded(true);
      })
      .catch((errs) => {
        console.log(errs);
      });
  }

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div>
      {!isLoaded && <Loading />}
      {isLoaded && (
        <Container>
          <Row className="m-0">
            <Col lg className="px-0 rounded-md shadow-sm" style={{ background: PALETTE.WHITE }}>
              <div className="py-2 px-3" style={{ borderRadius: "10px" }}>
                <Row
                  className="align-items-center align-self-center profile-section-clickable rounded-md"
                  onClick={() => { navigate("/account/AccountSettings"); }}
                >
                  <Col xs={4} className="text-center align-items-center">
                    <AccountAvatar
                      color={PALETTE.SECONDARYCOLOR}
                      completeText=""
                      firstname={user.firstname}
                      lastname={user.lastname}
                      borderColor={PALETTE.WHITE}
                      cover={user.cover || undefined}
                      size={60}
                      sizeInner={56}
                      fontSize={18}
                      completionPercentage={percentage}
                      showPercentageTag={false}
                    />
                  </Col>
                  <Col xs={8}>
                    <Row>
                      <Col className="px-2">
                        <div className="m-auto rounded-md p-2 text-center" style={{ minWidth: 70 }}>
                          <GiBodyHeight />
                          <p style={{ marginBottom: 0, marginTop: 4, fontSize: 15 }}>
                            <span
                              style={{
                                fontWeight: "bold",
                                color: PALETTE.DARKGRAY,
                              }}
                            >
                              {user.height}
                            </span>
                            <span style={{ fontSize: 14, color: PALETTE.DARKGRAY }}>
                              {" cm"}
                            </span>
                          </p>
                          <span style={{ fontSize: 12, color: PALETTE.GRAY }}>
                            Altezza
                          </span>
                        </div>
                      </Col>
                      <Col className="px-2">
                        <div className="m-auto rounded-md p-2 text-center" style={{ minWidth: 70 }}>
                          <FaWeightScale />
                          <p style={{ marginBottom: 0, marginTop: 4, fontSize: 15 }}>
                            <span
                              style={{
                                fontWeight: "bold",
                                color: PALETTE.DARKGRAY,
                              }}
                            >
                              {user.weight}
                            </span>
                            <span style={{ fontSize: 14, color: PALETTE.DARKGRAY }}>
                              {" kg"}
                            </span>
                          </p>
                          <span style={{ fontSize: 12, color: PALETTE.GRAY }}>
                            Peso
                          </span>
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </div>
              <hr className="my-1 mx-4" style={{ color: PALETTE.TRUEKINDAGRAY }} />
              <SkillsModal
                exercises={exerciseList}
                show={showModal}
                onHide={() => setShowModal(false)}
                onSubmit={fetchData}
              />
              {data.length === 0 ? (
                <div className="text-center my-4">
                  <p style={{ color: PALETTE.GRAY }}>Nessuna preferenza</p>
                </div>
              ) : (
                <SkillsRadar user={user} data={data} />
              )}

              <div
                className="profile-section-clickable rounded-md my-1 mx-1"
                onClick={() => setShowModal(true)}
              >
                <Row className="m-auto rounded-md" style={{ width: "100%" }}>
                  <Col xs={2} className="text-start align-self-center px-3">
                    <AiOutlineRadarChart
                      size={26}
                      color={PALETTE.DARK}
                      style={{ cursor: "pointer" }}
                    />
                  </Col>
                  <Col xs={8} className="text-start align-self-center px-0">
                    <p className="mb-0" style={{ fontWeight: "bold", fontSize: 14, color: PALETTE.DARK }}>
                      Skills e preferenze
                    </p>
                    <p className="mb-0" style={{ color: PALETTE.GRAY, fontSize: 12 }}>
                      Modifica le tue skills da monitorare
                    </p>
                  </Col>
                  <Col xs={2} className="text-end align-self-center px-3">
                    <IoChevronForwardOutline
                      size={20}
                      color={PALETTE.DARKGRAY}
                      style={{ cursor: "pointer" }}
                      onClick={() => setShowModal(true)}
                    />
                  </Col>
                </Row>
              </div>
            </Col>
            <Col lg className="px-0 rounded-md">
              <div className="m-auto py-1">
                {data.map((dataElement, idx) => {
                  if (dataElement.subject === "") {
                    return <div key={idx} />;
                  }
                  let color = PALETTE.MAINCOLOR;
                  let sign = "";
                  let value = "";
                  if (dataElement.trend > 0) {
                    color = PALETTE.GREEN;
                    sign = "+";
                    value = dataElement.trend;
                  } else if (dataElement.trend < 0) {
                    color = PALETTE.RED;
                    value = dataElement.trend;
                  }
                  return (
                    <>
                      <div
                        key={idx}
                        className="px-3 py-2 my-2 rounded-md"
                      >
                        <Row className="m-0 px-0">
                          <Col xs={7} className="text-start" style={{ paddingRight: 0, paddingLeft: 4 }}>
                            {dataElement.name}
                          </Col>
                          <Col
                            xs={3}
                            className="text-end px-0"
                            style={{ color: PALETTE.DARK }}
                          >
                            <span style={{ fontWeight: "bold" }}>
                              {dataElement.A}
                            </span>
                            <span style={{ color: PALETTE.DARKGRAY }}> kg</span>
                          </Col>
                          <Col
                            xs={2}
                            className="text-start align-self-center"
                            style={{
                              fontWeight: "bold",
                              color: color,
                              fontSize: "12px",
                            }}
                          >
                            {sign}
                            {value}
                          </Col>
                          {/* <Col xs={2} className="text-end align-self-center" style={{ paddingRight: 4, paddingLeft: 0 }}>
                          <FaChartLine size={20} color={PALETTE.MAINCOLOR} />
                        </Col> */}
                        </Row>
                      </div>
                      <hr className="my-0 mx-4" style={{ color: PALETTE.TRUEKINDAGRAY }} />
                    </>
                  );
                })}
              </div>
            </Col>
          </Row>
        </Container >
      )
      }
    </div >
  );
}
